// --- utilities
import { Scrolllable, BrowserCheck } from '@utilities';

// --- components
import {
  Header,
  Footer,
  HeroBanner,
  HeroBannerMobile,
  ExperienceDetail,
  ModalDetail,
  Projects,
  ContentTransition
} from '@components';

// --- App
const App = (() => {
  // --- run transition
  const runTransition = () => {
    $('body').removeClass('hold-transition');
  };

  // --- show site content
  const showSiteContent = () => {
    setTimeout(() => {
      $('body').removeClass('body--prepared');
      setTimeout(() => {
        // --- disable scroll
        Scrolllable.enable();
      }, 250);
    }, 100);
  };

  // --- ready
  const ready = () => {
    (($) => {
      // --- disable scroll
      Scrolllable.disable();

      // --- global
      runTransition();
      showSiteContent();
      BrowserCheck.init();

      // --- components
      Header.init();
      Footer.init();
      HeroBanner.init();
      HeroBannerMobile.init();
      ExperienceDetail.init();
      ModalDetail.init();
      Projects.init();
      ContentTransition.init();
    })(jQuery);
  };

  // --- load
  const load = () => {
    (($) => {
      $(window).on('load', () => {});
    })(jQuery);
  };

  // --- init
  const init = () => {
    load();
    ready();
  };

  // --- return
  return {
    init
  };
})();

// ---  run main js
App.init();
